<script>


import moment from "moment";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {

  },
  props: {
    wmsosList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    empreData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    updating: {
      type: Boolean,
    },
  },

  data() {
    return {
      userLogged: {},
      loadingDetail: false,
      valorTotalItens: 0,
      titleModalItensPed: 'Resumo de Ordem de Serviço',
      showModalItensPed: false,
      clienteData: {},
      wmsOsData: {},
      wmsOsItensData: {},
    };
  },

  mounted() {
    console.log('mounted wmsos-table')
    console.log(this.updating)

    this.userLogged = JSON.parse(localStorage.getItem('user'))

  },



  methods: {





    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'AB':
          result = 'Em Aberto'
          break
        case 'SE':
          result = 'Separado'
          break
        case 'CA':
          result = 'Cancelado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    nomeOrigem(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'movcompra':
          result = 'Compra'
          break
        case 'pedido':
          result = 'Pedido'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    nomeStatusSefaz(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'XM':
          result = 'XML Disponível'
          break
        case 'AT':
          result = 'NFe Autorizada'
          break
        case 'CA':
          result = 'NFe Cancelada'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    editar(dataObj){
      console.log('editar: ' + dataObj.id)
      console.log('empreData: ' + this.empreData.regtrib)

      if (dataObj.origem === 'movcompra') {
        this.$router.push(`/wmsos/entradaeditarnova/${dataObj.id}`)
      } else if (dataObj.origem === 'pedido') {

        this.$router.push(`/wmsos/entradaeditarnova/${dataObj.id}`)

        // if (this.empreData.regtrib === '99') {
        //   this.$router.push(`/wmsos/saidaeditarnova/${dataObj.id}`)
        // } else {
        //
        // }


      } else if (dataObj.origem === 'mov') {
        this.$router.push(`/wmsos/saidaeditar/${dataObj.id}`)
      }





    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.loadingDetail = true
      this.showModalItensPed = true
      this.valorTotalItens = 0

      api.get(`${getBaseUrl()}api/wmsos`, {
        params: { iddata: idData }
      }).then((res) => {
        console.log('then axios_detalhe')
        this.wmsOsData = res.data[0]
        this.clienteData = res.data[1]
        this.wmsOsItensData = res.data[2]

        console.log(res.data)

        if (this.wmsOsItensData.length > 0){
          this.wmsOsItensData.forEach((value) => {

            console.log('value.imgs')
            console.log(value.imgs)

            let imgTrat = value.imgs.split(',')
            // if (value.imgs.includes(',')){
            //   imgTrat = value.imgs.split(',')[0]
            // }else{
            //   imgTrat = value.imgs
            // }

            value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            // console.log(value.vlrtotalliq);
            let valorliq = parseFloat(value.valorliq)
            this.valorTotalItens += valorliq
          });
        }


        this.titleModalItensPed = `Resumo de Ordem de Serviço (${ this.wmsOsData.id })`
        this.loadingDetail = false
      })
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>
        <th class="align-middle">Selecionar</th>
        <th class="align-middle">ID</th>
        <th class="align-middle">Núm.N.F.</th>
        <th class="align-middle">Romaneio</th>
        <th class="align-middle">Pessoa</th>
        <th class="align-middle">Transportador</th>
        <th class="align-middle">Data</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Romaneio</th>
        <th class="align-middle">Condição</th>
        <th class="align-middle text-end">Peso</th>
        <th class="align-middle text-end">Valor</th>
        <th class="text-end">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in wmsosList" :key="data.id">


        <td style="width: 40px">
          <b-form-checkbox
              v-if="!data.wmsroma_id"
              class="form-check"
              v-model="data.checked"
          >
          </b-form-checkbox>
        </td>

        <td>
          <a href="javascript: void(0);" @click="editar(data)" class="text-body fw-bold">{{
              data.id
            }}</a>
        </td>

        <td>
          <a href="javascript: void(0);" @click="editar(data)" class="text-body fw-bold">{{
              data.codigo
            }}</a>
        </td>

        <td>{{ data.wmsroma_id }}</td>
        <td>{{ data.nomecli }}</td>
        <td>{{ data.nometransp }}</td>
        <td>{{ formatDateTime(data.created_at) }}</td>


        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="{
                  'badge-soft-warning': `${data.status}` === 'AB',
                  'badge-soft-danger': `${data.status}` === 'CA',
                  'badge-soft-success': `${data.status}` === 'FA',
                }">{{ nomeStatus(data.status) }} </span>
          <p></p>


          <span
              class="badge badge-pill badge-soft-success font-size-11"
              :class="data.percsep === 100.00 ? 'badge-soft-success'
                  :data.percsep === 0.00 ? 'badge-soft-danger' : 'badge-soft-warning'">
                {{ formatInteger(data.percsep)  }} %
              </span>


        </td>

        <td>
          {{ data.wmsroma_id }}
        </td>
        <td class="text-end">{{ formatDecimal(data.peso) }}</td>
        <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
        <td>

          <div class="button-items text-end">

<!--            <b-button variant="outline-success" @click="detalhes(data.id)">-->
<!--              <i class="mdi mdi-eye d-block font-size-16"></i>-->
<!--            </b-button>-->

            <b-button variant="outline-warning" @click="editar(data)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

          </div>

        </td>

      </tr>
      </tbody>
    </table>




    <b-modal :title="titleModalItensPed" v-model="showModalItensPed" centered hide-footer >

      <div class="row" v-if="loadingDetail">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingDetail && wmsOsData && clienteData">


        <p class="mb-2">
          Código:
          <span class="text-primary">{{ wmsOsData.id }}</span>
        </p>
        <p class="mb-4">
          <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank">
            Cliente:
            <span class="text-primary">{{ wmsOsData.cliente }} - {{ clienteData.nome }}</span>
          </router-link>
        </p>
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Produto</th>
              <th scope="col">Descrição</th>
              <th scope="col">Valor</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="data in wmsOsItensData" :key="data.id">
              <th scope="row">
                <div>
                  <img :src="data.img1"
                       alt
                       class="avatar-sm"/>
                </div>
              </th>
              <td>
                <div>
                  <h5 class="text-truncate font-size-14">
                    {{ data.descprod.substring(0, 32) }}
                  </h5>
                  <p class="text-muted mb-0">R$ {{ formatDecimal(data.vlrunitliq) }} x {{ formatInteger(data.qtd) }}</p>
                </div>
              </td>
              <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Sub Total:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Frete:</h6>
              </td>
              <td class="text-end">Grátis</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Total:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

  </div>
  <!-- end table -->
</template>
